import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getClients } from '../redux/actions/clients';
import { StoreState } from '../types/state';

const useClients = () => {
  const { clients, clientCount } = useSelector((state: StoreState) => {
    return {
      clients: state.clients.clients,
      clientCount: state.clients.clientCount,
    };
  });

  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (clientCount === -1) {
      setIsLoading(true);
      dispatch(getClients());
    } else {
      setIsLoading(false);
    }
  }, [dispatch, clientCount]);

  return { clients, count: clientCount, isLoading };
};

export default useClients;
